import { MenuItem, Select } from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSegment } from 'common/hooks/segment';
import { SegmentEvent } from 'services/helpers/segment';
import { encodePresetFilters, PresetView, PRESET_DEFINITIONS } from '../Containers/types';

export const HeaderLabel: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = (props) => {
  return <h2 className={`font-medium ${props.className}`}>{props.children}</h2>;
};

interface Props {
  children?: React.ReactNode;
  presetView: PresetView;
}

export const Header: React.FC<Props> = (props) => {
  const { children, presetView } = props;

  const navigate = useNavigate();
  const { track } = useSegment();

  const items = React.useMemo(() => {
    const presets = Object.values(PRESET_DEFINITIONS).filter((p) => p.access.includes('dropdown'));
    return presets.map((preset) => {
      return (
        <MenuItem key={preset.presetView} value={preset.presetView} className="font-medium text-sm">
          {preset.label}
        </MenuItem>
      );
    });
  }, []);

  const isDropdown = PRESET_DEFINITIONS[presetView].access.includes('dropdown');

  return (
    <div className="flex space-x-2 items-center shrink-0">
      {isDropdown ? (
        <Select
          value={presetView}
          onChange={(e) => {
            const presetDefinition = PRESET_DEFINITIONS[e.target.value as PresetView];
            const preset = encodePresetFilters(presetDefinition);

            track(
              SegmentEvent.ShipmentWatchlistPrefilteredViewUsed,
              {
                from: presetView,
                to: preset.presetView,
                filters: preset.filters,
              },
              { includeUser: true, includeCompany: true }
            );

            navigate(preset.to);
          }}
          renderValue={(value: PresetView) => (
            <HeaderLabel>{PRESET_DEFINITIONS[value].label}</HeaderLabel>
          )}
          variant="standard"
          IconComponent={KeyboardArrowDownIcon}
          disableUnderline
          classes={{
            icon: 'text-gray-500',
          }}
        >
          {items}
        </Select>
      ) : (
        <HeaderLabel>{PRESET_DEFINITIONS[presetView].label}</HeaderLabel>
      )}
      {children}
    </div>
  );
};
Header.displayName = 'Shipments.Header';
